var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.8L7.20002 12H16.8L6.68002 1.87997H5.56002C3.85362 2.95956 2.44865 4.454 1.47635 6.22373C0.504049 7.99346 -0.00387289 9.98074 2.22351e-05 12C2.22351e-05 18.64 5.36002 24 12 24C13.76 24 15.48 23.6 17 22.92V21.8Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.24 0 8.52 0.4 7 1.08V3L15.4 11.4H7V12.68L16.44 22.12H18.44C21.8 20 24 16.24 24 12C24 5.36 18.64 0 12 0Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00027 1.07999C6.48027 1.31999 6.00027 1.55999 5.52027 1.87999L14.8803 11.2H5.28027L17.0003 22.92C17.5203 22.68 18.0003 22.44 18.4803 22.12L9.12027 12.8H18.7203L7.00027 1.07999Z",
    fill: "#428BC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0398 7.92001C7.1598 7.72001 7.1998 7.44001 7.1998 7.20001C7.1998 6.32001 6.4798 5.60001 5.5998 5.60001C4.7198 5.60001 3.9998 6.32001 3.9998 7.20001C3.9998 7.48001 4.0798 7.72001 4.1598 7.92001C3.3998 7.60001 2.7998 7.20001 2.7998 7.20001C2.7998 7.20001 3.3998 9.60001 5.5998 9.60001C7.8398 9.60001 8.3998 7.20001 8.3998 7.20001C8.3998 7.20001 7.7998 7.60001 7.0398 7.92001ZM5.5998 15.04L6.2398 14.4L6.4798 15.28L7.3598 15.04L7.1198 15.92L7.9998 16.16L7.3598 16.8L7.9998 17.44L7.1198 17.68L7.3598 18.56L6.4798 18.32L6.2398 19.2L5.5998 18.56L4.9598 19.2L4.7198 18.32L3.8398 18.56L4.0798 17.68L3.1998 17.44L3.8398 16.8L3.1998 16.16L4.0798 15.92L3.8398 15.04L4.7198 15.28L4.9598 14.4L5.5998 15.04Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNep);
export default __webpack_public_path__ + "static/media/NEP.2c64f32d495f46d6e5268daf74be2a84.svg";
export { ForwardRef as ReactComponent };